import { render } from "./legoSearchBox.vue?vue&type=template&id=ab5a43ca"
import script from "./legoSearchBox.vue?vue&type=script&lang=js"
export * from "./legoSearchBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoSearchBox/legoSearchBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab5a43ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab5a43ca', __exports__)) {
    api.reload('ab5a43ca', __exports__)
  }
  
  module.hot.accept("./legoSearchBox.vue?vue&type=template&id=ab5a43ca", () => {
    api.rerender('ab5a43ca', render)
  })

}


export default __exports__